import { TGetMyOrganizationResDto } from "@/api/services/main/organization/dtos/get-my-organization.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { useQuery } from "@tanstack/react-query";

export const fetchMyOrganizationApi = async (): Promise<TGetMyOrganizationResDto> => {
  const { data } = await clientApi.get<TGetMyOrganizationResDto>("/organization/me");
  return data;
};

export const useMyOrganization = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.ORGANIZATION.FETCH_ME],
    queryFn: async () => {
      const res = await fetchMyOrganizationApi();
      return res;
    },
  });
};
